import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import { DURATION } from "../data/globalStyles"

const styles = {
  button: {
    minHeight: "50px",
    width: "311px",
    maxWidth: "311px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 0.8rem 0.8rem 0.8rem",
    border: `2px solid ${colors.white}`,
    borderRadius: "12px",
    backgroundColor: colors.white,
    color: colors.black,
    transition: `background-color ${DURATION} ease-in-out,
      color ${DURATION} ease-in-out,
      border ${DURATION} ease-in-out`,
    "@media only screen and (max-width: 810px)": {
      flex: "none",
      maxWidth: "235px",
      width: "90%",
    },
  },
  activeButton: {
    composes: "$button",
    border: `2px solid ${colors.black}`,
    backgroundColor: colors.black,
    color: colors.white,
  },
  hover: {
    cursor: "pointer",
    "&:hover, &:focus": {
      border: `2px solid ${colors.black}`,
      backgroundColor: colors.black,
      color: colors.white,
    },
  },
  text: {
    margin: "0 15px",
    fontWeight: "700",
    fontSize: "calc(16px + (22 - 16) * ((100vw - 300px) / (1600 - 300)))",
    textDecoration: "none",
    textAlign: "center",
    pointerEvents: "none",
  },
}

const AnswerButton = ({
  classes,
  data: { optionId, text, selected },
  lockAnswer,
  onClick,
}) => {
  const keyHandler = ({ code }) => {
    if (code === "Enter") {
      onClick()
    }
  }

  const getClassName = (selected, lockAnswer) => {
    return `${selected === true ? classes.activeButton : classes.button} ${
      !lockAnswer ? classes.hover : ""
    }`
  }

  return (
    <div
      key={`${optionId}-${text}`}
      className={getClassName(selected, lockAnswer)}
      onClick={onClick}
      onKeyDown={(e) => keyHandler(e)}
      tabIndex="0">
      <p className={classes.text}>{text}</p>
    </div>
  )
}

export default withStyles(styles)(AnswerButton)
